import React from "react";
import { LegalLayout } from "../../components/LegalLayout";
import { LEGAL } from "../../lib/legal";

export default function Disclaimer() {
  return (
    <LegalLayout title="General Disclaimer" testid="legal-disclaimer-page">
      <p>
        <strong>{LEGAL.companyName} is not a financial adviser, broker, dealer, or fiduciary.</strong> All content on
        the Service — including dashboards, charts, strategy templates, AI-generated rationales, Alpha Signals,
        leaderboards, simulated performance, and editorial copy — is provided for informational and educational purposes
        only. Nothing constitutes a recommendation or solicitation to buy or sell any security, derivative,
        cryptocurrency, or other instrument.
      </p>

      <h2>"AI Alpha Signals" Disclaimer</h2>
      <p>
        Alpha Signals are computed from anonymized aggregate trade data, market statistics, and natural-language
        reasoning generated by third-party large language models. They are <strong>probabilistic observations</strong>,
        not predictions. They may be wrong. They are not investment advice. Past correlations do not guarantee future
        performance. You alone are responsible for any action you take based on a signal.
      </p>

      <h2>Simulated Results</h2>
      <p>
        Simulated and paper-trading results have inherent limitations. They are computed with idealized fills, zero
        latency, and full liquidity. Real-world execution involves slippage, fees, partial fills, exchange downtime, and
        many other frictions. <strong>Simulated performance is not indicative of future real-money performance.</strong>
      </p>

      <h2>Forward-Looking Statements</h2>
      <p>
        Any forward-looking statements (for example, descriptions of strategies, expected behaviors, or roadmap items)
        are subject to risks and uncertainties. Actual results may differ materially.
      </p>

      <h2>Third-Party Information</h2>
      <p>
        Market data, prices, and exchange status displayed on the Service originate from third-party providers
        (e.g., CoinGecko, exchanges, AI model APIs). We do not guarantee the accuracy, timeliness, or completeness of
        such information.
      </p>

      <h2>No Solicitation</h2>
      <p>
        Nothing on the Service is intended as an offer or solicitation of any securities or financial product in any
        jurisdiction where such offer or solicitation would be unlawful.
      </p>

      <h2>Hold Harmless</h2>
      <p>
        You agree to hold {LEGAL.companyName} harmless from any decision or outcome resulting from your use of the
        Service. If you do not accept this, do not use the Service.
      </p>
    </LegalLayout>
  );
}
